import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import App from './App.vue'
import './assets/css/index.css'
import './assets/css/style.less'
import website from '@/config/website';
import router from "@/router/index.js"
import store from "@/store/store.js"
Vue.use(ElementUI);
import VueAwesomeSwiper from 'vue-awesome-swiper'
import * as echarts from 'echarts'; 
// 并设置对应的属性
Vue.prototype.$echarts = echarts; 
// 加载website
Vue.prototype.website = website;

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
